import { GUEST_RESERVATION_AUTH } from './../../environments/environment';
import { ROLES } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticateService } from '../share/authenticate/authenticate.service';
import { tap } from 'rxjs/operators';
import { SMILE9_ROLES } from '../../environments/environment';
import { CONSTANT } from '../../constant/constant';
import { Smile9UserSettings } from '../share/authenticate/auth-if';

@Injectable()
export class RoleGuard implements CanActivate {

  constructor(
    private authServ: AuthenticateService,
    private router: Router,
   ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot ): Observable<boolean> | boolean {
    this.authServ.inputUrl = '';
    this.authServ.inputUrlQueryParams.length = 0;
    return this.authServ.isAuthenticated().pipe(
      tap(loggedIn => {
        if (!loggedIn) {
          this.authServ.jumpToLoginPage();
        } else {
          this.checkRolesAndAuth(state);
        }
      })
    );
  }

  private checkRolesAndAuth(state: RouterStateSnapshot): void {
    let isRouterLinkOk = true;

    const roleRequired = [];
    const serviceRoleRequired = [];
    const smile9RoleRequired = [];
    const createPayrollKbnRequired = [];
    const hojoKbnRequired = [];
    const hojoGrpCodeRequired = [];
    const mainCafeCodeRequired = [];
    const guestReservationAuthRequired = [];
    const reducedTaxKbnRequired = [];
    const ugOptionsRequired = [];
    const smile9UserSettingsRequired: Smile9UserSettings[] = [];

    const role = this.authServ.role;
    const serviceRole = this.authServ.serviceRole;
    const smile9Role = this.authServ.smile9Role;
    const createPayrollKbn = this.authServ.createPayrollKbn;
    const hojoKbn = this.authServ.hojoKbn;
    const hojoGrpCode = this.authServ.hojoGrpCode;
    const mainCafeCode = this.authServ.mainCafeCode;
    const guestReservationAuth = this.authServ.guestReservationAuth;
    const reducedTaxKbn = this.authServ.reducedTaxKbn;
    const validUgOptions: string[] = this.authServ.getAllValidUgOptions('1');
    const validSmile9UserSettings: string[] = this.authServ.smile9UserSettings.filter(x => x.value === '1').map(x => x.item);
    const smile9UserSettings: Smile9UserSettings[] = this.authServ.smile9UserSettings;

    let pathname;
    const pos = state.url.indexOf('?');
    if (pos >= 0) {
      pathname = state.url.substring(0, pos);
    } else {
      pathname = state.url;
    }

    switch (pathname) {
      // smile9ロールごとに初期遷移ページを分岐
      case '/':
        if (smile9Role === SMILE9_ROLES.GENERAL_AFFAIRS) {
          this.router.navigateByUrl('/general-affairs/reservation/ga-rsv-result');
        }
        if (smile9Role === SMILE9_ROLES.FSC) {
          this.router.navigateByUrl('/fsc/fsc-rsv-result');
        }
        if (smile9Role === SMILE9_ROLES.KITCHEN) {
          this.router.navigateByUrl('/kitchen/kitchen-rsv-result');
        }
        if (smile9Role === SMILE9_ROLES.INDIVIDUAL) {
          if (validSmile9UserSettings.indexOf(CONSTANT.SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR) !== -1) {
            this.router.navigateByUrl('/individual/indi-rsv-calendar');
          } else {
            this.router.navigateByUrl('/individual/reservation-list');
          }
        }
        if (smile9Role === SMILE9_ROLES.SYSTEM) {
          this.authServ.signOut();
        }
        if (smile9Role === SMILE9_ROLES.ITADAKIMASU) {
          // ユーザーグループオプションによって遷移先を変更
          if (validUgOptions.indexOf(CONSTANT.UG_OPTION.ITADAKIMASU) !== -1) {
            this.router.navigate(['/scan-card/itadakimasu'], { queryParams: { validateCafeFunc: 1 } });
          } else if (validUgOptions.indexOf(CONSTANT.UG_OPTION.NO_RSV_ITADAKIMASU) !== -1) {
            this.router.navigate(['/scan-card/no-rsv-itadakimasu'], { queryParams: { validateCafeFunc: 1 } });
          } else if (validUgOptions.indexOf(CONSTANT.UG_OPTION.CAFETERIA) !== -1) {
            this.router.navigate(['/scan-card/scan-cafeteria'], { queryParams: { validateCafeFunc: 1 } });
          } else if (validUgOptions.indexOf(CONSTANT.UG_OPTION.SELF_REGI) !== -1) {
            this.router.navigate(['/scan-card/self-regi'], { queryParams: { validateCafeFunc: 1 } });
          } else {
            // カードスキャン系オプション全てが利用不可だった場合はサインアウト
            this.authServ.signOut();
            console.warn('signOut because no valid ug_option.');
          }
        }
        if (smile9Role === SMILE9_ROLES.MENU_DISPLAY) {
          this.router.navigateByUrl('/cafemenu-term/display-menu');
        }
        if (smile9Role === SMILE9_ROLES.FSC) {
          this.router.navigateByUrl('/fsc/fsc-rsv-result');
        }
        break;

      // 個人
      case '/individual/reservation-list':
        if (validSmile9UserSettings.indexOf(CONSTANT.SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR) !== -1) {
          this.router.navigateByUrl('/individual/indi-rsv-calendar');
        }
        smile9RoleRequired.push(SMILE9_ROLES.INDIVIDUAL);
        break;
      case '/individual/input-reservation':
        if (validSmile9UserSettings.indexOf(CONSTANT.SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR) !== -1) {
          this.router.navigateByUrl('/individual/indi-rsv-calendar');
        }
        smile9RoleRequired.push(SMILE9_ROLES.INDIVIDUAL);
        break;
      case '/individual/g-reservation-list':
        smile9RoleRequired.push(SMILE9_ROLES.INDIVIDUAL);
        guestReservationAuthRequired.push(GUEST_RESERVATION_AUTH.AUTHORIZED);
        break;
      case '/individual/g-input-reservation':
        smile9RoleRequired.push(SMILE9_ROLES.INDIVIDUAL);
        guestReservationAuthRequired.push(GUEST_RESERVATION_AUTH.AUTHORIZED);
        break;
      case '/individual/selfregi-usage-history':
        smile9RoleRequired.push(SMILE9_ROLES.INDIVIDUAL);
        break;
      case '/individual/indi-rsv-calendar':
        smile9RoleRequired.push(SMILE9_ROLES.INDIVIDUAL);
        smile9UserSettingsRequired.push({item: CONSTANT.SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, value: '1', ug_id_user: null});
        break;
      case '/individual/auto-rsv-settings':
        smile9RoleRequired.push(SMILE9_ROLES.INDIVIDUAL);
        smile9UserSettingsRequired.push({item: CONSTANT.SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, value: '1', ug_id_user: null});
        break;
      case '/individual/nutrition-balance':
        smile9RoleRequired.push(SMILE9_ROLES.INDIVIDUAL);
        smile9UserSettingsRequired.push({item: CONSTANT.SMILE9_USER_SETTINGS.ALLOW_NUTRITION_BALANCE, value: '1', ug_id_user: null});
        break;
      case '/individual/personal-data':
        smile9RoleRequired.push(SMILE9_ROLES.INDIVIDUAL);
        break;
        
      // 総務
      case '/general-affairs/general-affairs/ga-modify-rsv':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        smile9UserSettingsRequired.push({item: CONSTANT.SMILE9_USER_SETTINGS.ALLOW_GA_MODIFY_RSV, value: '1', ug_id_user: null});
        break;
      case '/general-affairs/general-affairs/modify-result':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        smile9UserSettingsRequired.push({item: CONSTANT.SMILE9_USER_SETTINGS.ALLOW_GA_MODIFY_ATE, value: '1', ug_id_user: null});
        break;
      case '/general-affairs/general-affairs/faxmail-settings':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        smile9UserSettingsRequired.push({item: CONSTANT.SMILE9_USER_SETTINGS.ALLOW_FAXMAIL_SETTINGS, value: '1', ug_id_user: null});
        break;
      case '/general-affairs/general-affairs/dl-data':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/general-affairs/dl-data-custom':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/general-affairs/guest-info':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/general-affairs/register-felica':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/general-affairs/automenu':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/general-affairs/ga-menu-list':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/general-affairs/ga-nutrition-balance':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        smile9UserSettingsRequired.push({item: CONSTANT.SMILE9_USER_SETTINGS.ALLOW_NUTRITION_BALANCE, value: '1', ug_id_user: null});
        break;
      case '/general-affairs/master/company':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/department':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/employee':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/send-mail':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/import-emp-csv':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/holiday-pattern':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/cafeteria':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/bill':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/cafe-bill':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/cafe-opening-hours':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/itadakimasu-settings':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        smile9UserSettingsRequired.push({item: CONSTANT.SMILE9_USER_SETTINGS.DISPLAY_GA_ITADAKIMASU_SETTINGS, value: '1', ug_id_user: null});
        break;
      case '/general-affairs/master/cafe-business-calendar':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/sei-kbn':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/menu-type':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/sub-menu-group':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        ugOptionsRequired.push(CONSTANT.UG_OPTION.SUB_MENU);
        break;
      case '/general-affairs/master/menu-tanka':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/cafe-hojo-group':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/cafe-hojo-settings':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/menu-pattern':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/sub-menu-pattern':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        ugOptionsRequired.push(CONSTANT.UG_OPTION.SUB_MENU);
        break;
      case '/general-affairs/master/disp-price':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/cafe-available-group':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/master/cafe-available-settings':
        roleRequired.push(ROLES.ADMIN_USER);
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;

      case '/general-affairs/reservation/ga-dashboard':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        smile9UserSettingsRequired.push({item: CONSTANT.SMILE9_USER_SETTINGS.ALLOW_DASHBOARD, value: '1', ug_id_user: null});
        break;
      case '/general-affairs/reservation/ga-rsv-result':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/reservation/ga-rsv-status':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/reservation/ga-input-rsv':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/reservation/ga-edit-rsv':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/reservation/update-in-bulk':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/reservation/ga-individual-rsv-status':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/reservation/modify-regi-result':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/reservation/ga-selfregi-rsv-result':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/reservation/ga-individual-regi-rsv-status':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/reservation/rsv-log':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;
      case '/general-affairs/reservation/retire-rsv':
        smile9RoleRequired.push(SMILE9_ROLES.GENERAL_AFFAIRS);
        break;

      // 給食センター
      case '/fsc/fsc-dashboard':
        smile9RoleRequired.push(SMILE9_ROLES.FSC);
        smile9UserSettingsRequired.push({item: CONSTANT.SMILE9_USER_SETTINGS.ALLOW_DASHBOARD, value: '1', ug_id_user: null});
        break;
      case '/fsc/import-menu-csv':
        smile9RoleRequired.push(SMILE9_ROLES.FSC);
        break;
      case '/fsc/fsc-rsv-result':
        smile9RoleRequired.push(SMILE9_ROLES.FSC);
        break;
      case '/fsc/kondate-class-list':
        smile9RoleRequired.push(SMILE9_ROLES.FSC);
        break;
      case '/fsc/kondate-list':
        smile9RoleRequired.push(SMILE9_ROLES.FSC);
        break;
      case '/fsc/kondate-otomo-list':
        smile9RoleRequired.push(SMILE9_ROLES.FSC);
        break;
      case '/fsc/sub-menu-list':
        smile9RoleRequired.push(SMILE9_ROLES.FSC);
        ugOptionsRequired.push(CONSTANT.UG_OPTION.SUB_MENU);
        break;
      case '/fsc/sub-menu-settings':
        smile9RoleRequired.push(SMILE9_ROLES.FSC);
        ugOptionsRequired.push(CONSTANT.UG_OPTION.SUB_MENU);
        break;
      case '/fsc/menu-list':
        smile9RoleRequired.push(SMILE9_ROLES.FSC);
        break;
      case '/fsc/self-regi-menu-list':
        smile9RoleRequired.push(SMILE9_ROLES.FSC);
        ugOptionsRequired.push(CONSTANT.UG_OPTION.SELF_REGI);
        break;
      case '/fsc/print-invoice':
        // [TODO]一時的に停止
        smile9RoleRequired.push(SMILE9_ROLES.SYSTEM);
        break;
      case '/fsc/fsc-selfregi-rsv-result':
        smile9RoleRequired.push(SMILE9_ROLES.FSC);
        ugOptionsRequired.push(CONSTANT.UG_OPTION.SELF_REGI);
        break;
      case '/pwchange':
        smile9RoleRequired.push(SMILE9_ROLES.FSC);
        break;
      case '/mailchange':
        smile9RoleRequired.push(SMILE9_ROLES.FSC);
        break;

      // 厨房
      case '/kitchen/kitchen-rsv-result':
        smile9RoleRequired.push(SMILE9_ROLES.KITCHEN);
        break;

      // カードスキャン端末
      case '/scan-card/itadakimasu':
        smile9RoleRequired.push(SMILE9_ROLES.ITADAKIMASU);
        break;
      case '/scan-card/no-rsv-scan-card':
        smile9RoleRequired.push(SMILE9_ROLES.ITADAKIMASU);
        break;
      case '/scan-card/scan-cafeteria':
        smile9RoleRequired.push(SMILE9_ROLES.ITADAKIMASU);
        break;
      case '/scan-card/self-regi':
        smile9RoleRequired.push(SMILE9_ROLES.ITADAKIMASU);
        break;

      // 食堂メニュー表示端末
      case '/cafemenu-term/display-menu':
        smile9RoleRequired.push(SMILE9_ROLES.MENU_DISPLAY);
        break;

      // その他ページ
      default:
        break;
    }

    if (roleRequired.length > 0 && roleRequired.indexOf(role) === -1) {
      console.warn('no role.');
      isRouterLinkOk = false;
    }
    if (serviceRoleRequired.length > 0 && serviceRoleRequired.indexOf(serviceRole) === -1) {
      console.warn('no service role.');
      isRouterLinkOk = false;
    }
    if (smile9RoleRequired.length > 0 && smile9RoleRequired.indexOf(smile9Role) === -1) {
      console.warn('no smile9role.');
      isRouterLinkOk = false;
    }
    if (createPayrollKbnRequired.length > 0 && createPayrollKbnRequired.indexOf(createPayrollKbn) === -1) {
      console.warn('no CreatePayrollKbn.');
      isRouterLinkOk = false;
    }
    if (hojoKbnRequired.length > 0 && hojoKbnRequired.indexOf(hojoKbn) === -1) {
      console.warn('no hojoKbn.');
      isRouterLinkOk = false;
    }
    if (hojoGrpCodeRequired.length > 0 && hojoGrpCodeRequired.indexOf(hojoGrpCode) === -1) {
      console.warn('no hojoGrpCode.');
      isRouterLinkOk = false;
    }
    if (mainCafeCodeRequired.length > 0 && mainCafeCodeRequired.indexOf(mainCafeCode) === -1) {
      console.warn('no mainCafeCode.');
      isRouterLinkOk = false;
    }
    if (guestReservationAuthRequired.length > 0 && guestReservationAuthRequired.indexOf(guestReservationAuth) === -1) {
      console.warn('no guestReservationAuth.');
      isRouterLinkOk = false;
    }
    if (reducedTaxKbnRequired.length > 0 && reducedTaxKbnRequired.indexOf(reducedTaxKbn) === -1) {
      console.warn('no reducedTaxKbn.');
      isRouterLinkOk = false;
    }
    if (ugOptionsRequired.length > 0 && !ugOptionsRequired.some(requiredOption => validUgOptions.some(option => option === requiredOption))) {
      console.warn('no requiredUgOption.');
      isRouterLinkOk = false;
    }
    if (smile9UserSettingsRequired.length > 0 &&
        !smile9UserSettingsRequired.some(requiredSettings =>
            smile9UserSettings.some(setting => setting.item === requiredSettings.item &&
                                               setting.value === requiredSettings.value))
    ) {
      console.warn('no requiredSmile9UserSettings.');
      isRouterLinkOk = false;
    }
    if (!isRouterLinkOk) {
      console.warn('<<<<< ROLE Guard >>>>>');
      this.authServ.signOut();
    }
  }
}
